import React, { useContext, useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
	Typography,
	Button,
	Paper,
	Grid,
	TextField,
} from "@material-ui/core";

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";

import SaveIcon from "@material-ui/icons/Save";

import SettingsInputCompositeIcon from "@material-ui/icons/SettingsInputComposite";


const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto"
	},
	actionButtons: theme.actionButtons,
	settingsGroup: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},
	dropzone: {
		padding: 20,
		height: 200,
		minHeight: 200,
		fontFamily: "Roboto, 'Segoe UI', 'Helvetica Neue', Arial",
		fontSize: 13,
		textTransform: "uppercase",
		letterSpacing: 1,
		"& p": {
			fontSize: 13,
		},
	},
}));

export default function UserSettings(props) {
	const theme = useTheme();
	const classes = useStyles();
	// Achtung Key verändert sich nach dem laden
	// aus bankaustria_user wird bankaustria_user__1 für user id 1
	const [settings, setSettings] = useState(
		{
			bankaustria_user: { // deprecated
				setting_type: "string",
				key: "bankaustria_user",
			},
			bankaustria_password: { // deprecated
				setting_type: "string",
				key: "bankaustria_password",
			},
			bankaustria_berater_nr: {
				setting_type: "string",
				key: "bankaustria_berater_nr",
			},
			// ing_user: {
			// 	setting_type: "string",
			// 	key: "ing_user",
			// },
			// ing_password: {
			// 	setting_type: "string",
			// 	key: "ing_password",
			// },
			bawag_persnr: {
				setting_type: "string",
				key: "bawag_persnr",
			},
			bawag_user: {
				setting_type: "string",
				key: "bawag_user",
			},
			bawag_password: {
				setting_type: "string",
				key: "bawag_password",
			},
			start_persnr: {
				setting_type: "string",
				key: "start_persnr",
			},
			start_user: {
				setting_type: "string",
				key: "start_user",
			},
			start_password: {
				setting_type: "string",
				key: "start_password",
			}
		}
	);
	const pageContext = useContext(PageContext);
	const userContext = useContext(UserContext);

	useEffect(() => {
		Object.keys(settings).forEach((key) => {
			getSetting(key);
		})
	}, []);


	const getSetting = (key) => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${settings[key].setting_type}/${key}`,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then(({ data }) => {
				setSettings(settings => {
					// console.log({ ...settings, [key]: data });
					return { ...settings, [key]: data };
				})
			})
			.catch((err) => {
				if (err.response && err.response.data && err.response.data.message)
					pageContext.setErrorMessage(err.response.data.message);
				else
					pageContext.setErrorMessage("Die Einstellung konnte nicht geladen werden!");
			});
	}


	const saveSetting = (key) => {
		const setting = settings[key];
		setSettings(settings => {
			return { ...settings, [key]: { ...setting, status: "saving" } };
		})

		const value_key = setting.setting_type == "string"
			? "value"
			: setting.setting_type == "boolean"
				? "value_boolean"
				: "value_numeric";

		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${key}`,
			data: {
				[value_key]: setting[value_key]
			},
			method: 'put',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				console.log(settings)
				setSettings(settings => {
					return { ...settings, [key]: { ...setting, status: "" } };
				})
				pageContext.setInfoMessage("Einstellung wurde gespeichert");
			})
			.catch((err) => {
				console.log(err);
				setSettings(settings => {
					return { ...settings, [key]: { ...setting, status: "" } };
				})
				pageContext.setErrorMessage("Einstellung konnte nicht gespeichert werden!");
			});
	}

	const checkChannel = (channel_shortname) => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/checkchannel/${channel_shortname}`,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				if (res.data.success && res.data.message)
					pageContext.setInfoMessage(res.data.message);
				else if (res.data.success)
					pageContext.setInfoMessage(res.data.message);
				else
					pageContext.setErrorMessage(res.data.message);
			})
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Die Verbindung konnte nicht hergestellt werden!");
			});
	}

	const uploadFile = (setting, file, action = null) => {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("setting_key", setting.key);

		const headers = userContext.getRequestAuthHeader(false);

		axios.post(
			`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads`,
			formData, {
			headers: headers
		})
			.then(({ data }) => {
				getSetting(setting);
				pageContext.setInfoMessage(data.message);
			})
			.catch((err) => {
				pageContext.setErrorMessage("Die Datei konnte nicht gespeichert werden!");
			});
	};

	return (
		<div className={classes.root}>
			<div className={classes.actionButtons}>

			</div>
			<Typography variant="h2">Persönliche Einstellungen</Typography>
			<Typography>Hier kannst du die Einstellungen für deinen Account festlegen.</Typography>
			<br />
			{/* <Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">Bankaustria (alt)</Typography>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="text"
							name="bankaustria_user"
							value={settings.bankaustria_user.value ? settings.bankaustria_user.value : ""}
							// error={error !== null}
							// helperText={error}
							label="Benutzername"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value, status: "modified" } })
							}}
							onBlur={() => {

							}}
							disabled={settings.bankaustria_user.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="password"
							name="bankaustria_password"
							value={settings.bankaustria_password.value ? settings.bankaustria_password.value : ""}
							// error={error !== null}
							// helperText={error}
							label="Passwort"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value, status: "modified" } })
							}}
							disabled={settings.bankaustria_password.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bankaustria_user.status === "saving"
								|| settings.bankaustria_password.status === "saving"
							}
							onClick={() => {
								saveSetting("bankaustria_user");
								saveSetting("bankaustria_password");
							}}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bankaustria_user.status === "saving"
								|| settings.bankaustria_password.status === "saving"
								|| settings.bankaustria_user.status === "modified"
								|| settings.bankaustria_password.status === "modified"
							}
							onClick={() => {
								checkChannel("BANKAUSTRIA")
							}}
							startIcon={<SettingsInputCompositeIcon />}
						>
							Verbindung prüfen
						</Button>
					</Grid>
				</Grid>
			</Paper> */}
			<Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">Bankaustria</Typography>
					</Grid>
					<Grid item xs={6} md={3}>
						<TextField
							fullWidth
							type="text"
							name="bankaustria_berater_nr"
							value={settings.bankaustria_berater_nr.value ? settings.bankaustria_berater_nr.value : ""}
							// error={error !== null}
							helperText="Die Beraternummer findest du in FinService unter dem Button 'Partner'"
							label="Berater Nummer"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value, status: "modified" } })
							}}
							onBlur={() => {

							}}
							disabled={settings.bankaustria_berater_nr.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={5}></Grid>
					<Grid item xs={6} md={4}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bankaustria_berater_nr.status === "saving"
							}
							onClick={() => {
								saveSetting("bankaustria_berater_nr");
							}}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bankaustria_berater_nr.status === "saving"
								|| settings.bankaustria_berater_nr.status === "modified"
							}
							onClick={() => {
								checkChannel("BANKAUSTRIAAPI")
							}}
							startIcon={<SettingsInputCompositeIcon />}
						>
							Verbindung prüfen
						</Button>
					</Grid>
				</Grid>
			</Paper>
			{/* <Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">Bank99</Typography>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="text"
							name="ing_user"
							value={settings.ing_user.value ? settings.ing_user.value : ""}
							// error={error !== null}
							// helperText={error}
							label="Benutzername"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value, status: "modified" } })
							}}
							onBlur={() => {

							}}
							disabled={settings.ing_user.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="password"
							name="ing_password"
							value={settings.ing_password.value ? settings.ing_password.value : ""}
							// error={error !== null}
							// helperText={error}
							label="Passwort"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value, status: "modified" } })
							}}
							disabled={settings.ing_password.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.ing_user.status === "saving"
								|| settings.ing_password.status === "saving"
							}
							onClick={() => {
								saveSetting("ing_user");
								saveSetting("ing_password");
							}}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.ing_user.status === "saving"
								|| settings.ing_password.status === "saving"
								|| settings.ing_user.status === "modified"
								|| settings.ing_password.status === "modified"
							}
							onClick={() => {
								checkChannel("ING")
							}}
							startIcon={<SettingsInputCompositeIcon />}
						>
							Verbindung prüfen
						</Button>
					</Grid>
				</Grid>
			</Paper> */}
			<Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">BAWAG</Typography>
					</Grid>
					<Grid item xs={6} md={3}>
						<TextField
							fullWidth
							type="text"
							name="bawag_persnr"
							value={settings.bawag_persnr.value ? settings.bawag_persnr.value : ""}
							// error={error !== null}
							// helperText={error}
							label="PersNr."
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							onBlur={() => {

							}}
							disabled={settings.bawag_persnr.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={3}>
						<TextField
							fullWidth
							type="text"
							name="bawag_user"
							value={settings.bawag_user.value ? settings.bawag_user.value : ""}
							label="Benutzername"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							onBlur={() => {

							}}
							disabled={settings.bawag_user.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="password"
							name="bawag_password"
							value={settings.bawag_password.value ? settings.bawag_password.value : ""}
							helperText="Das Schnittstellen-Passwort ist nicht das normale Passwort. Dieses bekommst du nur über den Support."
							label="API Passwort"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							disabled={settings.bawag_password.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={2}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bawag_persnr.status === "saving"
								|| settings.bawag_user.status === "saving"
								|| settings.bawag_password.status === "saving"
							}
							onClick={() => {
								saveSetting("bawag_persnr");
								saveSetting("bawag_user");
								saveSetting("bawag_password");
							}}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
						{/* <Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bawag_persnr.status === "saving"
								|| settings.bawag_user.status === "saving"
								|| settings.bawag_password.status === "saving"
							}
							onClick={() => {
								checkChannel("BAWAG")
							}}
							startIcon={<SettingsInputCompositeIcon />}
						>
							Verbindung prüfen
						</Button> */}
					</Grid>
				</Grid>
			</Paper>
			<Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">Start Bausparkasse</Typography>
					</Grid>
					<Grid item xs={6} md={3}>
						<TextField
							fullWidth
							type="text"
							name="start_persnr"
							value={settings.start_persnr.value ? settings.start_persnr.value : ""}
							// error={error !== null}
							// helperText={error}
							label="PersNr."
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							onBlur={() => {

							}}
							disabled={settings.start_persnr.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={3}>
						<TextField
							fullWidth
							type="text"
							name="start_user"
							value={settings.start_user.value ? settings.start_user.value : ""}
							label="Benutzername"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							onBlur={() => {

							}}
							disabled={settings.start_user.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="password"
							name="start_password"
							value={settings.start_password.value ? settings.start_password.value : ""}
							helperText="Das Schnittstellen-Passwort ist nicht das normale Passwort. Dieses bekommst du nur über den Support."
							label="API Passwort"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							disabled={settings.start_password.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={2}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.start_persnr.status === "saving"
								|| settings.start_user.status === "saving"
								|| settings.start_password.status === "saving"
							}
							onClick={() => {
								saveSetting("start_persnr");
								saveSetting("start_user");
								saveSetting("start_password");
							}}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
					</Grid>
				</Grid>
			</Paper>
		</div>
	);
}
